import moment from "moment";
import { RootState } from "../reducers";
import { createSelector } from "reselect";

export const adminSelector = (state: RootState) => state.adminReducer;

export const initDataLoadingSelector = (state: RootState) =>
  adminSelector(state).initDataLoading;
export const citiesSelector = (state: RootState) => adminSelector(state).cities;
export const communitiesSelector = (state: RootState) =>
  adminSelector(state).communities;
export const languagesSelector = (state: RootState) =>
  adminSelector(state).languages;
export const additionalProgramsSelector = (state: RootState) =>
  adminSelector(state).additionalPrograms;
export const errorSelector = (state: RootState) => adminSelector(state).error;
export const newWitnessIdSelector = (state: RootState) =>
  adminSelector(state).newWitnessId;
export const duplicateWitnessNamesSelector = (state: RootState) =>
  adminSelector(state).duplicateWitnessNames;
export const volunteerListSelector = (state: RootState) =>
  adminSelector(state).volunteerList;
export const salondaysSelector = (state: RootState) =>
  adminSelector(state).salondays;
export const userCitySelector = (state: RootState) =>
  adminSelector(state).userCity;
export const numOfActiveFiltersSelector = (state: RootState) =>
  adminSelector(state).numOfActiveFilters;
export const hostSalonTrainingSelector = (state: RootState) =>
  adminSelector(state).hostSalonTraining;

const adjustDefaultSalonDate = (defaultSalonDate: Date, futureSalonDaysDates: Date[], today: Date): Date | null => {
  const currentTime = new Date();
  let finalDate = defaultSalonDate;
  const isTodayAndAfterSevenPM = defaultSalonDate.toDateString() === today.toDateString() && currentTime.getHours() >= 19

  if (isTodayAndAfterSevenPM) {
    finalDate = futureSalonDaysDates[1] || null;
  }

  if (finalDate) {
    finalDate.setHours(19, 0, 0, 0);
  }

  return finalDate;
};
export const salonDatesSelector = createSelector(
  salondaysSelector,
  (salonDays) => {
    const today = moment().startOf("day");

    // Normalize salonDays to UTC "YYYY-MM-DD" strings to ensure consistent date comparisons and ordering across all timezones
    const futureSalonDaysDates = salonDays
      .map(({ date }) => moment.utc(date).format("YYYY-MM-DD"))
      .filter((dateStr) => moment.utc(dateStr).isSameOrAfter(today))
      .sort();      

    const defaultFutureSalonDayDate = salonDays
      .filter(({ default_for_year }) => default_for_year)
      .map(({ date }) => moment.utc(date).format("YYYY-MM-DD"))
      .find((dateStr) => moment.utc(dateStr).isSameOrAfter(today));

    const todayStr = today.format("YYYY-MM-DD");

    let defaultSalonDateStr =
      futureSalonDaysDates.find((d) => d === todayStr) ||
      defaultFutureSalonDayDate ||
      futureSalonDaysDates[0] ||
      null;

    const parsedFutureSalonDates = futureSalonDaysDates.map((dateStr) =>
      moment(dateStr).toDate()
    );    

    const parsedDefaultSalonDate = defaultSalonDateStr
      ? adjustDefaultSalonDate(
          moment(defaultSalonDateStr).toDate(),
          parsedFutureSalonDates,
          today.toDate()
        )
      : null;  

    return {
      salonDays: parsedFutureSalonDates,
      defaultSalonDate: parsedDefaultSalonDate,
    };
  }
);